//OK
$("#formLogin").validate({
  submitHandler: function (form) {
    //SUBMIT form
    $(form).ajaxSubmit({
      //target: 'status-envio',
      beforeSubmit: function () {
        $("#formLogin #btnLogin")
          .addClass("loader")
          .html(__("Enviando...Aguarde."))
          .attr("disabled", true);
      },
      success: function (result) {
        result = result.split("|");
        if (parseInt(result[1]) == 1) {
          $("#formLogin #btnLogin")
            .removeClass("loader")
            .addClass("success")
            .html(result[2]);
          if (result[4]) {
            setTimeout(function () {
              location.href = "./profissional/" + result[4];
            }, 2000);
          } else {
            setTimeout(function () {
              location.href = "./" + result[3];
            }, 2000);
          }
        } else {
          $("#formLogin #btnLogin")
            .removeClass("loader")
            .addClass("error")
            .html(result[2]);
          setTimeout(function () {
            $("#formLogin #btnLogin")
              .removeClass("error")
              .html("Login")
              .attr("disabled", false);
          }, 3000);
          if (result[3] !== undefined) {
            $(".step-form").prepend(
              '<div class="alert alert-danger" role="alert">' +
                result[3] +
                "</div>"
            );
            setTimeout(function () {
              $(".step-form .alert-danger").remove();
            }, 4000);
          }
        }
      },
    });
  },
});

$("#formLoginQRCode").validate({
  submitHandler: function (form) {
    //SUBMIT form
    $(form).ajaxSubmit({
      //target: 'status-envio',
      beforeSubmit: function () {
        $("#formLoginQRCode #btnLogin")
          .addClass("loader")
          .html(__("Validando...Aguarde."))
          .attr("disabled", true);
      },
      success: function (result) {
        result = result.split("|");
        if (parseInt(result[1]) == 1) {
          //$('#formLoginQRCode #btnLogin').removeClass('loader').addClass('success').html(result[2]);
          Swal.fire({
            title: "Check-in realizado!",
            text: "Você ganhou pontos no seu perfil do Viva Docol!",
            icon: "success",
            iconColor: "#00a9e0",
            showConfirmButton: false,
            showCancelButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            timer: 5000,
          }).then(function (result) {
            location.href = "login";
          });
        } else {
          //$('#formLoginQRCode #btnLogin').removeClass('loader').addClass('error').html(result[2]);
          Swal.fire({
            title: result[2],
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#00a9e0",
            confirmButtonText: "Ok",
            timer: 3000,
          }).then(function (result) {
            $("#formLoginQRCode #btnLogin")
              .removeClass("error")
              .html("Validar")
              .attr("disabled", false);
          });
        }
      },
    });
  },
});

if ($(".formCadastroStep1").length) {
  $(".formCadastroStep1").validate({
    rules: {
      email_cad: "required",
      email_confirm: {
        equalTo: "#email_cad",
      },
    },
    submitHandler: function (form) {
      //SUBMIT form
      $(form).ajaxSubmit({
        //target: 'status-envio',
        beforeSubmit: function () {
          $(".formCadastroStep1 .c-stsSend").removeClass("d-none");
          $(".formCadastroStep1 .c-stsSend__feedback--load").removeClass(
            "d-none"
          );
          $(".formCadastroStep1  #btnStep1").attr("disabled", true);
        },
        success: function (result) {
          result = result.split("|");
          console.log(result);

          if (parseInt(result[1]) == 1) {
            $(".formCadastroStep1 .c-stsSend__feedback").addClass("d-none");
            $(".formCadastroStep1 .c-stsSend__feedback--success").removeClass(
              "d-none"
            );
            $(".formCadastroStep1 .c-stsSend__feedback--success span").html(
              result[2]
            );
            $("#cod_cadastro").val(atob(result[3]));
            $("#email_cadastro").val(atob(result[4]));
            $("#nome_cadastro").val(atob(result[5]));
            setTimeout(function () {
              //location.reload();
              $(".formCadastroStep1 input").attr("readonly", "readonly");
              $(".formCadastroStep1 #btnStep1")
                .attr("disabled", false)
                .addClass("d-none");
              $(".formCadastroStep1 .c-stsSend").addClass("d-none");
              $(".formCadastroStep1 .c-stsSend__feedback").addClass("d-none");
              $(".formCadastroStep2").removeClass("d-none");
              $(".formCadastroStep1").addClass("d-none");
            }, 2000);
          } else if (parseInt(result[1]) == 2) {
            setTimeout(function () {
              $(".formCadastroStep1 .c-stsSend").addClass("d-none");
              $(".formCadastroStep1 .c-stsSend__feedback").addClass("d-none");
              $(".formCadastroStep1 #btnStep1").attr("disabled", false);
            }, 2000);
            Swal.fire({
              title: result[2],
              text: result[3],
              icon: "warning",
              allowOutsideClick: false,
              showCancelButton: true,
              confirmButtonColor: "#3e3e3e",
              cancelButtonColor: "#d33",
              confirmButtonText: result[4],
            }).then(function (res) {
              if (res.value) {
                location.href = result[5];
                //conslole.log(result[5])
              }
            });
          } else {
            $(".formCadastroStep1 .c-stsSend__feedback").addClass("d-none");
            $(".formCadastroStep1 .c-stsSend__feedback--error").removeClass(
              "d-none"
            );
            $(".formCadastroStep1 .c-stsSend__feedback--error span").html(
              result[2]
            );
            setTimeout(function () {
              $(".formCadastroStep1 .c-stsSend").addClass("d-none");
              $(".formCadastroStep1 .c-stsSend__feedback").addClass("d-none");
              $(".formCadastroStep1 #btnStep1").attr("disabled", false);
            }, 3000);
          }
        },
      });
    },
  });

  $("#formCadastroStep1__pais").on("change", function () {
    var pais = $(this).val();
    var ddi = $(this).find("option:selected").attr("data-ddi");
    $(".cad_estado").html(
      '<option value="">' + __("Carregando estados...") + "</option>"
    );
    $("#formCadastroStep1__ddi").val(ddi);
    $.ajax({
      type: "POST",
      data: { pais: pais },
      url: "ajax-estados.php",
      success: function (result) {
        $(".cad_estado").html(result);
        $(".cad_cidade").html(
          '<option value="">' + __("Aguardando") + "</option>"
        );
      },
    });
    if ($(this).val() === "BR") {
      $(".l_BR").removeClass("d-none");
      $(".l_ES").addClass("d-none");
      $("#formCadastroStep1__telefone").addClass("foneMask");
      $("#formCadastroStep2__CREA")
        .attr("required", "required")
        .removeAttr("readonly")
        .val("");
      $("#formCadastroStep2__CEP").addClass("cepMask");
      $("#formCadastroStep2__CEP")
        .attr("required", "required")
        .removeAttr("readonly")
        .val("");
      $(".cepMask").mask("99999-999");
      if (is.not.ie()) {
        $(".cpfMask").mask("999.999.999-99");
        $(".foneMask")
          .focusout(function () {
            var phone;
            $(".foneMask").unmask();
            phone = $(".foneMask").val().replace(/\D/g, "");
            if (phone.length > 10) {
              $(".foneMask").mask("(99) 99999-999?9");
            } else {
              $(".foneMask").mask("(99) 9999-9999?9");
            }
          })
          .trigger("focusout");
      }
    } else {
      $(".l_ES").removeClass("d-none");
      $(".l_BR").addClass("d-none");
      $("#formCadastroStep2__CREA")
        .removeClass("error")
        .removeAttr("required", "required")
        .attr("readonly", "readonly")
        .val("");
      $(".cepMask").unmask();
      $(".cpfMask").unmask();
      $(".foneMask").unmask();
      $("#formCadastroStep1__telefone").removeClass("foneMask");
      $("#formCadastroStep2__CEP").removeClass("error").val("");
      $("#formCadastroStep2__CEP").removeClass("cepMask");
    }
  });
}

if ($(".formCadastroStep2").length) {
  $("#formCadastroStep2__CPF").on("blur", (e) => {
    if ($("#formCadastroStep2__CPF").val().length === 14) {
      $.ajax({
        url: "verifica-cpf-existente?v=" + $("#formCadastroStep2__CPF").val(),
        success: function(res) {
          result = res.split("|");
          if (parseInt(result[1]) == 1) {
            Swal.fire({
              title: "Atenção",
              text: "Já existe um cadastro com este CPF, faça o login ou solicite a recuperação de senha.",
              allowOutsideClick: false,
              icon: "warning",
              showConfirmButton: true,
              confirmButtonText: "Fazer login",
              confirmButtonColor: "#3e3e3e",
              showCancelButton: true,
              cancelButtonText: "Recuperar senha",
              cancelButtonColor: "#00a9e0",
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              console.log(result);
              if (result.value) {
                location.href = "vd/profissional";
                console.log(2);
              } else {
                location.href = "vd/profissional/#recuperar-senha";
                console.log(3);
              }
            });
          }
        },
      });
    }
  });

  $(".formCadastroStep2").validate({
    rules: {
      formCadastroStep2__senha: "required",
      formCadastroStep2__senha2: {
        equalTo: "#formCadastroStep2__senha",
      },
    },
    submitHandler: function (form) {
      $(".formCadastroStep2 .c-stsSend").removeClass("d-none");
      var pais = $("#formCadastroStep1__pais").val();
      if (validaCPF($("#formCadastroStep2__CPF").val())) {
        //SUBMIT form
        $(form).ajaxSubmit({
          //target: 'status-envio',
          beforeSubmit: function () {
            $(".formCadastroStep2 .c-stsSend__feedback--load").removeClass(
              "d-none"
            );
            $(".formCadastroStep2  #btnStep2").attr("disabled", true);
          },
          success: function (result) {
            result = result.split("|");
            if (parseInt(result[1]) == 1) {
              $(".formCadastroStep2 .c-stsSend__feedback").addClass("d-none");
              $(".formCadastroStep2 .c-stsSend__feedback--success").removeClass(
                "d-none"
              );
              $(".formCadastroStep2 .c-stsSend__feedback--success span").html(
                result[2]
              );
              setTimeout(function () {
                window.location = "login";
              }, 5000);
            } else {
              $(".formCadastroStep2 .c-stsSend__feedback").addClass("d-none");
              $(".formCadastroStep2 .c-stsSend__feedback--error").removeClass(
                "d-none"
              );
              $(".formCadastroStep2 .c-stsSend__feedback--error span").html(
                result[2]
              );
              setTimeout(function () {
                $(".formCadastroStep2 .c-stsSend").addClass("d-none");
                $(".formCadastroStep2 .c-stsSend__feedback").addClass("d-none");
                $(".formCadastroStep2 #btnStep2").attr("disabled", false);
              }, 3000);
            }
          },
        });
      } else {
        console.log("CPF Inválido!");
        $(".formCadastroStep2 .c-stsSend__feedback").addClass("d-none");
        $(".formCadastroStep2 .c-stsSend__feedback--error").removeClass(
          "d-none"
        );
        $(".formCadastroStep2 .c-stsSend__feedback--error span").html(
          "CPF inválido!"
        );
        setTimeout(function () {
          $(".formCadastroStep2 .c-stsSend").addClass("d-none");
          $(".formCadastroStep2 .c-stsSend__feedback").addClass("d-none");
          $(".formCadastroStep2 #btnStep2").attr("disabled", false);
        }, 3000);
      }
    },
  });

  $("#formCadastroStep2__profissao").on("change", function () {
    var label = "CAU";
    if ($(this).val() === "Arquiteto") {
      label = "CAU";
      $("#formCadastroStep2__CREA")
        .attr("required", "required")
        .removeAttr("readonly")
        .val("");
    } else {
      label = '<span style="text-decoration: line-through;">CAU </span>';
      $("#formCadastroStep2__CREA")
        .removeClass("error")
        .removeAttr("required", "required")
        .attr("readonly", "readonly")
        .val("");
      $(".l_crea_cau").blur();
    }

    $(".l_crea_cau").html(label);
  });

  $("#formCadastroStep2__modalidade").on("change", function () {
    var mode = $(this).val();
    var pais = $("#formCadastroStep1__pais").val();

    if (mode === "A") {
      $(".l_BR span.opcional").show();
      $(".l_ES span.opcional").show();

      $("#formCadastroStep2__CNPJ").removeAttr("required", "required").val("");
      $("#formCadastroStep2__escritorio")
        .removeAttr("required", "required")
        .val("");
    } else {
      $(".l_BR span.opcional").hide();
      $(".l_ES span.opcional").hide();
      $("#formCadastroStep2__escritorio").attr("required", "required");
      if (pais === "BR") {
        $("#formCadastroStep2__CNPJ").attr("required", "required");
      } else {
        $("#formCadastroStep2__CNPJ")
          .removeAttr("required", "required")
          .val("");
      }
    }
  });
}

//OK
if ($(".formEsqueceuSenha").length) {
  $(".formEsqueceuSenha").validate({
    submitHandler: function (form) {
      //SUBMIT form
      $(form).ajaxSubmit({
        //target: 'status-envio',
        beforeSubmit: function () {
          $(".formEsqueceuSenha .c-stsSend").removeClass("d-none");
          $(".formEsqueceuSenha .c-stsSend__feedback--load").removeClass(
            "d-none"
          );
          $(".formEsqueceuSenha  #btnEmail").attr("disabled", true);
        },
        success: function (result) {
          result = result.split("|");
          if (parseInt(result[1]) == 1) {
            $(".formEsqueceuSenha .c-stsSend__feedback").addClass("d-none");
            $(".formEsqueceuSenha .c-stsSend__feedback--success").removeClass(
              "d-none"
            );
            $(".formEsqueceuSenha .c-stsSend__feedback--success span").html(
              result[2]
            );
            setTimeout(function () {
              //window.location = result[3]+'login';
              location.reload();
            }, 5000);
          } else {
            $(".formEsqueceuSenha .c-stsSend__feedback").addClass("d-none");
            $(".formEsqueceuSenha .c-stsSend__feedback--error").removeClass(
              "d-none"
            );
            $(".formEsqueceuSenha .c-stsSend__feedback--error span").html(
              result[2]
            );
            setTimeout(function () {
              $(".formEsqueceuSenha .c-stsSend").addClass("d-none");
              $(".formEsqueceuSenha .c-stsSend__feedback").addClass("d-none");
              $(".formEsqueceuSenha #btnEmail").attr("disabled", false);
            }, 3000);
          }
        },
      });
    },
  });
}

//OK
if ($(".form-sign-loja").length) {
  // STEP VERIFICA SE TEM LOJA
  $(document).on("click", "#btn-sign-loja", function (e) {
    e.preventDefault();
    $(".alert-ajax p").html("");
    $(".alert-ajax").addClass("d-none");
    var cnpj = $("#unikidloja").val();
    $(".alert-ajax p").html("Localizando a loja.");
    $(".alert-ajax").removeClass("d-none");
    $.ajax({
      type: "POST",
      data: { cnpj: cnpj },
      url: "check-cad-loja",
      success: function (result) {
        result = result.split("|");
        if (result[1] == 1) {
          // Removido por solicitação do Waldemar e Aleksandro em 29/07/2022
          //$('.row-1').removeClass('d-none');
          //$('.row-2').remove();
          //$('.row-3').remove();
          $(".row-1 .nome-loja").val(result[3]);
        } else if (result[1] == 2) {
          $(".row-1").remove();
          $(".row-2").removeClass("d-none");
          $(".row-2 .nome-loja").val(result[3]);
          $(".row-3").remove();
        } else if (result[1] == 3) {
          $(".row-1").remove();
          $(".row-2").remove();
          $(".row-3").removeClass("d-none");
          $(".row-3 .nome-loja").val(result[3]);
        } else if (result[1] == 4) {
          $(".row-1").remove();
          $(".row-2").remove();
          $(".row-3").remove();
        }
        $("#btn-sign-loja").hide();
        $(".alert-ajax p").html(result[2]);
        $(".cpfMask").mask("999.999.999-99");
      },
    });
  });

  // STEP 2
  $(".form-sign-loja").validate({
    rules: {
      email_cad: "required",
      email_cad_confirm: {
        equalTo: "#email_cad",
      },
      senha: "required",
      senha_confirm: {
        equalTo: "#senha",
      },
      email2_cad: "required",
      email2_cad_confirm: {
        equalTo: "#email2_cad",
      },
      senha2: "required",
      senha2_confirm: {
        equalTo: "#senha2",
      },
    },
    submitHandler: function (form) {
      //SUBMIT form
      $(form).ajaxSubmit({
        //target: 'status-envio',
        beforeSubmit: function () {
          $(".form-sign-loja .c-stsSend").removeClass("d-none");
          $(".form-sign-loja .c-stsSend__feedback--load").removeClass("d-none");
          $(".form-sign-loja  #btnEnviar").attr("disabled", true);
        },
        success: function (result) {
          result = result.split("|");
          if (parseInt(result[1]) == 1) {
            $(".form-sign-loja .c-stsSend__feedback").addClass("d-none");
            $(".form-sign-loja .c-stsSend__feedback--success").removeClass(
              "d-none"
            );
            $(".form-sign-loja .c-stsSend__feedback--success span").html(
              result[2]
            );
            setTimeout(function () {
              $(".form-sign-loja input").attr("readonly", "readonly");
              $(".form-sign-loja #btnEnviar")
                .attr("disabled", false)
                .addClass("d-none");
              $(".form-sign-loja .c-stsSend").addClass("d-none");
              $(".form-sign-loja .c-stsSend__feedback").addClass("d-none");
              $(".row-2").removeClass("d-none");
              location.reload();
            }, 4000);
          } else {
            $(".form-sign-loja .c-stsSend__feedback").addClass("d-none");
            $(".form-sign-loja .c-stsSend__feedback--error").removeClass(
              "d-none"
            );
            $(".form-sign-loja .c-stsSend__feedback--error span").html(
              result[2]
            );
            setTimeout(function () {
              $(".form-sign-loja .c-stsSend").addClass("d-none");
              $(".form-sign-loja .c-stsSend__feedback").addClass("d-none");
              $(".form-sign-loja #btnEnviar").attr("disabled", false);
            }, 3000);
          }
        },
      });
    },
  });
}

if ($("body").hasClass("home-popup")) {
  $(window).on("load", function () {
    Swal.fire({
      width: 800,
      //title: 'Sweet!',
      //text: 'Modal with a custom image.',
      imageUrl: "uploads/popups/lancamento-2021.jpeg",
      imageWidth: 800,
      imageAlt: "Custom image",
      showConfirmButton: true,
      confirmButtonColor: "#1c2f33",
      confirmButtonText: __("Cadastre-se"),

      showCancelButton: true,
      cancelButtonColor: "#00a9e0",
      cancelButtonText: __("Fechar"),

      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(function (result) {
      console.log(result, result.isConfirmed, result.value);
      if (result.value) {
        location.href = "https://ww1.docol.com/docol/webinar/?idc=NjU%3D&src=1";
      }
    });
  });
}
